import React from 'react'
import RenderLinkMsg from "./renderLinkMsg";
import RenderDocMsg from "./renderDocMsg";
import RenderFileMsg from "./renderFileMsg";
import RenderOther from "./renderOtherMsg";
import RenderTextMsg from "./renderTextMsg";
import RenderLocation from "./renderLoacation";
import RenderImgMsg from "./renderImgMsg";
import RenderVideoMsg from "./renderVideoMsg";
import RenderRedPackageMsg from "./renderRedPackage";
import RenderCardMsg from "./renderCardMsg";
import RenderAgreeMsg from "./renderAgreeMsg";

const RenderMixedMsg = (props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  // 渲染消息
  const renderMsg = (params) => {
    const {msgtype} = params
    switch (msgtype) {
      case 'text':
        return <RenderTextMsg value={params}/>
      case 'file':
        return <RenderFileMsg value={params}/>
      case 'image':
        return <RenderImgMsg value={params}/>
      case 'video':
        return <RenderVideoMsg value={params}/>
      case 'external_redpacket':
      case 'redpacket':
        return <RenderRedPackageMsg value={params}/>
      case 'location':
        return <RenderLocation value={params}/>
      case 'card':
        return <RenderCardMsg value={params}/>
      case 'agree':
      case 'disagree':
        return <RenderAgreeMsg value={params}/>
      // case 'chatrecord':
      //   return <RenderDialogue value={params}/>
      case 'link':
        return <RenderLinkMsg value={params}/>
      case 'docmsg': // 在线文档
        return <RenderDocMsg value={params}/>
      case 'revoke': // 撤回消息的操作不展示
        return null
      case 'mixed': // 混合消息
        return <RenderMixedMsg value={params}/>
      default:
        return <RenderOther value={params}/>
    }
  }
  return (
    <div>
      {message.itemRespList.map((item) => {
        return (
          <div key={item.id}>
            {renderMsg(item)}
          </div>
        )
      })}
    </div>
  )

}

export default RenderMixedMsg
